@use '../../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  width: fit-content; // Overridden by FLUID Page / FLUID Container styles
  display: block;

  .fluid-in-page-nav {
    position: sticky;
    top: 0; // Overridden by "_offsetTop" (if "sticky" Header exists)
    overflow-y: auto;

    // ==== Body

    .nav-body {
      padding-top: 2em;
    }

    // ==== Title

    .nav-list-title {
      margin-bottom: 1em;
    }
  }
}

// ==== Hidden (Responsive)

:host(.fluid-in-page-nav--hidden) {
  display: none;
}
